module.exports = __webpack_public_path__ + "img/indexSide-zh.741e7c29.png";